import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NavItem } from '../../../vertical/sidebar/nav-item/nav-item';

@Component({
  selector: 'app-horizontal-nav-item',
  standalone: true,
  imports: [TablerIconsModule, CommonModule, MatIconModule],
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  host: {
    '[class.nav-expanded]': 'expanded && !isRootLevel()',
  },
})
export class AppHorizontalNavItemComponent {
  @Input() depth = 0;
  @Input() item!: NavItem;

  /** Submenús anidados (depth > 0) abiertos por click */
  expanded = false;

  constructor(public router: Router) {}

  /** Primer nivel del menú horizontal: hover en CSS */
  isRootLevel(): boolean {
    return Number(this.depth) === 0;
  }

  /** Click: anidados abren/cierran; hojas navegan; raíz solo evita navegación */
  onItemClick(event: MouseEvent, item: NavItem): void {
    if (item.children?.length) {
      event.preventDefault();
      event.stopPropagation();
      if (this.isRootLevel()) {
        return;
      }
      this.expanded = !this.expanded;
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (item.route) {
      this.router.navigate([item.route]);
    }
  }
}
